class cartService {

    constructor($http, $q, translateService) {
        'ngInject';

        this.$http = $http;
        this.$q = $q;

        this.translate = translateService;

        this.loaded = false;
        this.loading = false;

        this.items = [];
        this.summary = null;
        this.summary_gros = null;
        this.currency = {
            symbol: null,
            symbol_placement: null
        };
    }

    load() {
        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.get('/ajax/cart/getCartContent').then(
            (response) => {
                const data = response.data;

                this.items = data.products;
                this.summary = data.summary;
                this.summary_gros = data.summary_gros;
                this.currency = data.currency;

                this.loading = false;
                this.loaded = true;

                deferred.resolve({
                    items: this.items,
                    summary: this.summary,
                    summary_gros: this.summary_gros
                });

                this.items.forEach((item, index) => {
                    if(item.productionFile){
                        item.productionFile = atob(item.productionFile);
                    }
                });
            },
            (response) => {
                this.loading = false;
                this.loaded = true;

                if (response.status == 404) {
                    this.items = [];
                    this.summary = null;
                    this.summary_gros = null;

                    deferred.resolve({
                        items: this.items,
                        summary: this.summary,
                        summary_gros: this.summary_gros
                    });

                    return;
                }

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }
}

export default cartService;
